export const initialState = {
  suppliersColumns: [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Supplier',
      align: 'left',
      sortable: true,
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: true,
      label: 'Email',
      align: 'center',
      sortable: true,
    },
    {
      id: 'contact',
      numeric: false,
      disablePadding: true,
      label: 'Contact name',
      align: 'center',
      sortable: true,
    },
    {
      id: 'phone',
      numeric: false,
      disablePadding: true,
      label: 'Phone Number',
      align: 'center',
      sortable: false,
    },
    {
      id: 'products',
      numeric: false,
      disablePadding: true,
      label: 'Products',
      align: 'center',
      sortable: false,
    },
    {
      id: 'shared',
      numeric: false,
      disablePadding: true,
      label: 'Shared',
      align: 'center',
      sortable: false,
    },
    {
      id: 'action',
      numeric: false,
      disablePadding: true,
      label: 'Info',
      align: 'center',
      sortable: false,
    },
  ],
  suppliers: {
    offset: 0,
    loading: false,
    hasMore: false,
    value: [],
    initialised: false,
  },
  autocompleteSuppliers: {
    offset: 0,
    loading: true,
    hasMore: false,
    value: [],
  },
  newSupplierForm: {
    loading: false,
  },
  selectedSupplier: {},
  categoriesColumns: [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Category',
      align: 'left',
      sortable: true,
    },
    {
      id: 'products',
      numeric: false,
      disablePadding: true,
      label: 'Products',
      align: 'center',
      sortable: false,
    },
    {
      id: 'shared',
      numeric: false,
      disablePadding: true,
      label: 'Shared',
      align: 'center',
      sortable: false,
    },
    {
      id: 'action',
      numeric: false,
      disablePadding: true,
      label: 'Info',
      align: 'center',
      sortable: false,
    },
  ],
  categories: {
    offset: 0,
    loading: false,
    hasMore: false,
    value: [],
    initialised: false,
  },
  newCategoryForm: {
    loading: false,
  },
  selectedCategory: {},
  productsColumns: [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Product',
      align: 'left',
      sortable: true,
    },
    {
      id: 'supplier',
      numeric: false,
      disablePadding: true,
      label: 'Supplier',
      align: 'center',
      sortable: true,
    },
    {
      id: 'category',
      numeric: false,
      disablePadding: true,
      label: 'Category',
      align: 'center',
      sortable: true,
    },
    {
      id: 'variants',
      numeric: false,
      disablePadding: true,
      label: 'Variants',
      align: 'center',
      sortable: false,
    },
    {
      id: 'price',
      numeric: false,
      disablePadding: true,
      label: 'Price',
      align: 'center',
      sortable: false,
    },
    {
      id: 'shared',
      numeric: false,
      disablePadding: true,
      label: 'Shared',
      align: 'center',
      sortable: false,
    },
    {
      id: 'action',
      numeric: false,
      disablePadding: true,
      label: 'Info',
      align: 'center',
      sortable: false,
    },
  ],
  products: {
    offset: 0,
    loading: false,
    hasMore: false,
    value: [],
    initialised: false,
  },
  newProductForm: {
    loading: false,
  },
  selectedProduct: {},
  selectedProductVariant: [],
  options: {
    categories: {
      next: null,
      loading: false,
      value: [],
    },
    suppliers: {
      next: null,
      loading: false,
      value: [],
    },
  },
};
